<template>
    <div class="form-group customebtnrow">
        <v-select label="text" :filterable="false"
                  v-model="quotationForm.quotation"
                  :options="quotations"
                  :multiple="multiple"
                  @search="onQuotationSearch"
                  @input="onQuotationSelect"
                  @selected="onQuotationSelect"
                  @deselected ="onQuotationDeSelect">
            <template slot="no-options">
                type to search quotations..
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center" v-html="option.html">
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center" v-html="option.text">
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions} from "vuex";

export default {
    name: "QuotationSelect",
    props:{
        quotation: {
            type: Object,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if(this.quotation) {
            this.quotationForm.quotation_id = this.quotation_id;

            let name  = '#' + this.quotation.quotation_number;
            if(this.quotation.quote_name && this.quotation.quote_name !== '') {
                name += ` (${this.quotation.quote_name})`;
            }

            this.quotationForm.quotation = {
                id: this.quotation.id,
                text: name,
                name: name,
                html: name,
            };
        }
    },
    data() {
        return {
            quotationForm: {
                quotation: null,
                quotation_id: null,
            },
            quotations: [],
            quotationData: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        onQuotationSelect(event){
            if(!this.multiple) {
                if (event) {
                    this.quotationForm.quotation_id = event.id;
                } else {
                    this.quotationForm.quotation_id = null;
                }
            }
            this.$emit('quotationSelectedEvent', event);
        },
        onQuotationDeSelect(event){
            if(!this.multiple) {
                this.quotationForm.quotation_id = null;
            }
            this.$emit('quotationSelectedEvent', event);
        },
        onQuotationSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchQuotation(loading, search, this);
            }
        },
        searchQuotation: _.debounce((loading, search, vm) => {
            return axios.get(window.route('quotations.searchNew'), {search: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.quotations = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
    },
}
</script>

<style scoped>

</style>
